import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { ErrorInterceptor } from './core/helpers/error.interceptor';
import { JwtInterceptor } from './core/helpers/jwt.interceptor';
import { LayoutsModule } from './layouts/layouts.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { provideOktaAuth, withOktaConfig } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import config from './app.config';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
import { ToastrModule } from 'ngx-toastr';
import { StoreModule } from '@ngrx/store';
import { appReducer } from './store';
import { EffectsModule } from '@ngrx/effects';
import { DashboardEffects } from './store/dashboard/dashboard.effects';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';

const oktaAuth = new OktaAuth(config.oidc);
export function playerFactory() {
  return player;
}
@NgModule({
  declarations: [
    AppComponent,
    PagenotfoundComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    LayoutsModule,
    AppRoutingModule,
    ToastrModule.forRoot(),
    StoreModule.forRoot(appReducer),
    EffectsModule.forRoot([DashboardEffects])
  ],
  providers: [
    Title,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    provideOktaAuth(withOktaConfig({ oktaAuth })),
    provideHttpClient(withInterceptorsFromDi()),
    provideLottieOptions({
      player: playerFactory
    })
  ]
})
export class AppModule { }
